import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, get, patch, post, put } from "helpers/api_helper"
import {
  ADD_USER,
  DELETE_USER,
  GET_ALL_USERS,
  GET_USER_DETAILS,
  GET_USER_LISTS,
  UPDATE_USER,
  RESET_USER_PASSWORD,
  ASSIGN_TRIAL_OPERATION_PERMISSION,
  GET_ASSIGNED_ROLE_DATA,
} from "helpers/url_helper"

export const getUserLists = createAsyncThunk(GET_USER_LISTS, async payload => {
  const response = await get(GET_USER_LISTS)
  return response
})

export const getAllUsers = createAsyncThunk(GET_ALL_USERS, async payload => {
  const response = await post(GET_ALL_USERS, payload)
  return response
})

export const addUser = createAsyncThunk(ADD_USER, async payload => {
  const response = await post(ADD_USER, payload)
  return response
})

export const updateUser = createAsyncThunk(UPDATE_USER, async data => {
  const { uuid, payload } = data

  const response = await put(`${UPDATE_USER}/${uuid}`, payload)
  return response
})

export const getUserDetails = createAsyncThunk(
  GET_USER_DETAILS + "GET_DETAILS",
  async uuid => {
    const response = await get(`${GET_USER_DETAILS}/${uuid}`)
    return response
  }
)

export const deleteUser = createAsyncThunk(
  DELETE_USER + "DELETE",
  async uuid => {
    const response = await del(`${DELETE_USER}/${uuid}`)
    return response
  }
)

export const resetUserPassword = createAsyncThunk(
  RESET_USER_PASSWORD,
  async payload => {
    const response = await post(RESET_USER_PASSWORD, payload)
    return response
  }
)

export const assignPermissionforTrialOperation = createAsyncThunk(
  ASSIGN_TRIAL_OPERATION_PERMISSION,
  async payload => {
    const response = await post(ASSIGN_TRIAL_OPERATION_PERMISSION, payload)
    return response
  }
)

export const getAssignedPermissionforTrialOperation = createAsyncThunk(
  GET_ASSIGNED_ROLE_DATA + "_trial_operation",
  async payload => {
    const response = await get(`${GET_ASSIGNED_ROLE_DATA}/${payload}`)
    return response
  }
)
